<template>
  <v-card outlined tile flat class="login_form">
    <v-layout column v-if="loadingUser === true" justify-center>
      <v-spacer></v-spacer>
      <v-flex class="loading" xs12>
        <v-layout row justify-center align-center fill-height>
          <v-spacer></v-spacer>
          <v-flex>
            <pulse-loader :loading="loadingUser === true" class="pa-4 ma-4"></pulse-loader>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
    <v-layout v-else-if="user.id === null" column class="login">
      <v-flex>
        <v-text-field
          label="EMAIL ADDRESS"
          :value="user.email"
          v-model="user.email"
          required
          box
        ></v-text-field>
      </v-flex>
      <v-flex>
        <v-text-field
          label="PASSWORD"
          :value="user.password"
          v-model="user.password"
					v-on:keyup="tryLogin"
          type="password"
          required
          box
        ></v-text-field>
      </v-flex>
      <v-flex align-center>
        <v-layout row wrap align-center>
          <v-flex xs7 md5>
            <v-btn @click="login()" class="primary">
              Login
            </v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs6 md4>
            <a @click="resetPassword()" class="accent">
              Forgot Password?
            </a>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-flex class="pa-4 pb-0">
        <v-layout column>
          <v-flex xs12 class="pb-2">
            <p>You are logged in as <strong>{{ user.name_first }} {{ user.name_last }}</strong>.</p>
          </v-flex>
          <v-flex xs12>
            <v-btn class="accent" @click="logout()">Logout</v-btn>
          </v-flex>
          <v-flex xs12>
            <v-btn class="accent" @click="goToUrl('/my-profile')">My Profile</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import store from "../../store";
import Shared from "@/mixins/Shared";
import { createHelpers } from "vuex-map-fields";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});

export default {
  name: "LoginForm",
  computed: {
    ...mapFields(["user"])
  },
  components: {PulseLoader},
  data: () => ({
    store: store,
    error: false,
    loadingLogin: false
  }),
  methods: {
    loadingState: function() {
      return this.loadingLogin;
    },
		tryLogin: function(e) {
			if (e.keyCode === 13) {
        event.preventDefault();
        this.login();
      }
		}
  },
  mounted: function() {
    this.loginTest();
  },
  mixins: [Shared]
};
</script>

<style></style>
